import { wingmanLogger } from './loggerService';

/**
 * 📊 Wingman Analytics Service
 * High-level tracker for key user value actions.
 */
export const trackEvent = (event: string, properties?: any) => {
    wingmanLogger.analytics(event, properties);
};

export const WingmanAnalytics = {
    search: (query: string, source: string = 'chat') => {
        trackEvent('SEARCH_TRIGGERED', { query, source });
    },
    save: (videoTitle: string, category: string) => {
        trackEvent('INTEL_SAVED', { title: videoTitle, category });
    },
    unsave: (videoTitle: string) => {
        trackEvent('INTEL_REMOVED', { title: videoTitle });
    },
    vaultOpen: (itemCount: number) => {
        trackEvent('VAULT_OPENED', { itemCount });
    },
    flyTo: (locationName: string | null, coordinates: [number, number]) => {
        trackEvent('SPATIAL_FLY_TO', { location: locationName, coordinates });
    },
    moduleError: (module: string, error: string) => {
        trackEvent('MODULE_FAILURE', { module, error });
    }
};
